import { cookieHelper } from '../../cookieHelper';
import { CookieKeyEnum } from '../../model/const';

export const getBearerToken = () => {
    const token = cookieHelper.get(CookieKeyEnum.USER_DATA)?.accessToken;
    return token ? `Bearer ${token}` : null;
};
